import { useEffect, useState } from "react";
import api from "../api/axios";
import { readStoredJson } from "../utilities/session";
import { Link } from "react-router-dom";

/* ---------------- ICONS ---------------- */
const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const BellIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

/* ---------------- FLAGS ---------------- */
const Flags = {
  BD: (
    <svg viewBox="0 0 640 480" width="24" height="24">
      <path fill="#006a4e" d="M0 0h640v480H0z" />
      <circle fill="#f42a41" cx="280" cy="240" r="160" />
    </svg>
  ),
  US: (
    <svg viewBox="0 0 640 480" width="24" height="24">
      <path fill="#bd3d44" d="M0 0h640v480H0" />
      <path stroke="#fff" strokeWidth="37" d="M0 55.3h640M0 129h640M0 202.8h640M0 276.5h640M0 350.2h640M0 423.9h640" />
      <path fill="#192f5d" d="M0 0h281.6v258.5H0z" />
    </svg>
  ),
};

const TopNavBar = ({ toggleSidebar, user, onLogout }) => {
  const googleUser = readStoredJson("googleUser", null);

  const [notifications, setNotifications] = useState([]);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [showNotiDropdown, setShowNotiDropdown] = useState(false);
  const [showFlagDropdown, setShowFlagDropdown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("BD");
  const [showAllNotifications, setShowAllNotifications] = useState(false);

  useEffect(() => {
    loadNotifications();
    const closeDropdowns = (e) => {
      if (!e.target.closest(".tnb-action-item")) {
        setShowUserDropdown(false);
        setShowNotiDropdown(false);
        setShowFlagDropdown(false);
      }
    };
    document.addEventListener("click", closeDropdowns);
    return () => document.removeEventListener("click", closeDropdowns);
  }, []);

  const loadNotifications = async () => {
    try {
      const res = await api.get("/api/notifications");
      setNotifications(res.data);
    } catch (err) {
    }
  };

  const clearNotifications = async () => {
    try {
      await api.delete("/api/notifications/clear");
      setNotifications([]);
    } catch (err) {
      setNotifications([]);
    }
  };

  const toggleDropdown = (type) => {
    setShowUserDropdown(type === "user" ? !showUserDropdown : false);
    setShowNotiDropdown(type === "noti" ? !showNotiDropdown : false);
    setShowFlagDropdown(type === "flag" ? !showFlagDropdown : false);
  };

  const avatarSrc = user?.profile_photo_path
    ? `${api.defaults.baseURL}/${user.profile_photo_path}`
    : googleUser?.picture || "/assets/images/users/avatar-1.jpg";

  return (
    <>
      <style>{`
        .tnb-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #4A90E2;
          padding: 0 20px;
          height: 70px;
          box-shadow: 0 2px 5px rgba(0,0,0,0.05);
          position: sticky;
          top: 0;
          z-index: 1000;
        }
        .tnb-left { display: flex; align-items: center; gap: 15px; }
        .tnb-toggle { background: none; border: none; cursor: pointer; color: white; padding: 5px; display:none }
        .tnb-search { display: flex; align-items: center; background: #f1f5f9; border-radius: 8px; padding: 5px 12px; }
        .tnb-search input { border: none; background: transparent; outline: none; padding: 5px; width: 180px; font-size: 0.9rem; }
        .tnb-search button { background: #4a90e2; color: white; border: none; padding: 5px 12px; border-radius: 6px; cursor: pointer; }
        
        .tnb-right { display: flex; align-items: center; gap: 12px; }
        .tnb-action-item { position: relative; }
        .tnb-icon-btn { cursor: pointer; padding: 8px; border-radius: 50%; display: flex; align-items: center; position: relative; color: white }
        
        .tnb-badge { position: absolute; top: 6px; right: 6px; width: 8px; height: 8px; background: #ef4444; border-radius: 50%; border: 2px solid white; }
        
        .tnb-user-box { display: flex; align-items: center; gap: 10px; cursor: pointer; padding: 5px 10px; border-radius: 50px; }
        .tnb-avatar { width: 38px; height: 38px; border-radius: 50%; object-fit: cover; border: 2px solid #e2e8f0; }
        .tnb-user-info { display: flex; flex-direction: column; line-height: 1.2; color: white}
        .tnb-name { font-size: 0.85rem; font-weight: 700; color: #1e293b; color: white}
        .tnb-role { font-size: 0.75rem; color: #64748b; color: white}

        .tnb-dropdown {
          position: absolute;
          top: 55px;
          right: 0;
          background: white;
          min-width: 200px;
          border-radius: 8px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border: 1px solid #e2e8f0;
          display: none;
          overflow: hidden;
        }
        .tnb-dropdown.tnb-show { display: block; animation: tnbSlide 0.2s ease-out; }
        .tnb-wide { min-width: 280px; }
        .tnb-drop-header { padding: 12px 15px; background: #f8fafc; border-bottom: 1px solid #e2e8f0; font-weight: 600; font-size: 0.8rem; }
        .tnb-drop-item { padding: 10px 15px; display: block; color: #475569; text-decoration: none; font-size: 0.85rem; cursor: pointer; }
        .tnb-drop-item:hover { background: #f1f5f9; }
        .tnb-notif-item { border-bottom: 1px solid #f1f5f9; padding: 12px 15px; }
        .tnb-notif-item p { margin: 3px 0; font-size: 0.8rem; color: #64748b; }

        @keyframes tnbSlide { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

        @media (max-width: 768px) {
          .tnb-search, .tnb-user-info { display: none; }
          .tnb-toggle { background: none; border: none; cursor: pointer; color: white; padding: 5px; display:inline }
          .tnb-header { padding: 0 10px; }
          .tnb-wide { right: -60px; }
        }
          
      `}</style>

      <header className="tnb-header">
        <div className="tnb-left">
          <button className="tnb-toggle" onClick={toggleSidebar}>
            <MenuIcon />
          </button>
          <div className="tnb-search">
            <input type="text" placeholder="Search..." />
            <button>Search</button>
          </div>
        </div>

        <div className="tnb-right">
          {/* Flag Dropdown */}
          <div className="tnb-action-item">
            <div className="tnb-icon-btn" onClick={(e) => { e.stopPropagation(); toggleDropdown("flag"); }}>
              {Flags[selectedCountry]}
            </div>
            <div className={`tnb-dropdown ${showFlagDropdown ? "tnb-show" : ""}`}>
              {Object.keys(Flags).map((key) => (
                <div key={key} className="tnb-drop-item" onClick={() => setSelectedCountry(key)}>
                  {Flags[key]} <span style={{ marginLeft: '8px' }}>{key}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Notifications */}
          <div className="tnb-action-item">
            <div className="tnb-icon-btn" onClick={(e) => { e.stopPropagation(); toggleDropdown("noti"); }}>
              <BellIcon />
              {notifications.length > 0 && <span className="tnb-badge"></span>}
            </div>
            <div className={`tnb-dropdown tnb-wide ${showNotiDropdown ? "tnb-show" : ""}`}>
              <div className="tnb-drop-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Notifications</span>
                {notifications.length > 0 && <small onClick={clearNotifications} style={{ color: '#ef4444', cursor: 'pointer' }}>Clear All</small>}
              </div>
              {notifications.length === 0 ? (
                <div className="tnb-drop-item" style={{ color: '#94a3b8' }}>No new alerts</div>
              ) : (
                <>
                  {(showAllNotifications ? notifications : notifications.slice(0, 3)).map((n, i) => (
                    <div key={i} className="tnb-notif-item">
                      <strong style={{ fontSize: '0.85rem' }}>{n.data?.title || "Update"}</strong>
                      <p>{n.data?.message}</p>
                      <small style={{ color: '#cbd5e1' }}>{new Date(n.created_at).toLocaleTimeString()}</small>
                    </div>
                  ))}
                  {notifications.length > 3 && !showAllNotifications && (
                    <div className="tnb-drop-item" style={{ textAlign: 'center', color: '#4a90e2' }} onClick={() => setShowAllNotifications(true)}>View All</div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* User Profile */}
          <div className="tnb-action-item">
            <div className="tnb-user-box" onClick={(e) => { e.stopPropagation(); toggleDropdown("user"); }}>
              <img src={avatarSrc} alt="user" className="tnb-avatar" />
              <div className="tnb-user-info">
                <span className="tnb-name">{user?.name || googleUser?.name}</span>
                <span className="tnb-role">{user?.mobile_number || "User"}</span>
              </div>
            </div>
            <div className={`tnb-dropdown ${showUserDropdown ? "tnb-show" : ""}`}>
              <div className="tnb-drop-header">Account Settings</div>
              <Link to="/profile" className="tnb-drop-item">My Profile</Link>
              {/* <Link to="/system-settings" className="tnb-drop-item">Settings</Link> */}
              <div className="tnb-drop-item" style={{ color: '#ef4444', borderTop: '1px solid #f1f5f9' }} onClick={onLogout}>Logout</div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default TopNavBar;
